<div>
    <div class="drop-message"
         [class.drop-message--visible]="isDropTarget">
        {{dropMessage}}
    </div>
    <div>
        <ng-content></ng-content>
    </div>
</div>
